// Global state for user subscription status and image count
let currentUserIsPro = false;
let memoryEnabled = JSON.parse(localStorage.getItem("chatMemory")) ?? true;
let dailyImageCount = 0;
const IMAGE_LIMIT_FREE_TIER = 3; // Max images for free users per day

let currentTheme = localStorage.getItem('theme') || 'dark';
export function isProUser() {
    return currentUserIsPro;
}
export function mapFirebaseError(code) {
    // console.error('Firebase error code:', code);
    switch (code) {
        case 'auth/user-not-found':
            return 'No user found with this email.';
        case 'auth/wrong-password':
            return 'Incorrect password.';
        case 'auth/email-already-in-use':
            return 'Email is already registered.';
        case 'auth/invalid-email':
            return 'Invalid email address.';
        case 'auth/weak-password':
            return 'Password should be at least 6 characters.';
        case 'auth/missing-email':
            return 'Enter your email address.';
        case 'auth/invalid-credential':
            return 'Invalid credentials provided.';
        case 'auth/too-many-requests':
            return 'Too many attempts. Try again later.';
        default:
            return 'An unexpected error occurred.';
    }
}

export function formatDate(timestamp) {
    return new Date(timestamp).toLocaleDateString();
}

export function updateThemeToggleButton() {
    const themeToggleButton = document.getElementById('themeToggleButton'); // Get the button by its new ID
    if (themeToggleButton) {
        const iconSpan = themeToggleButton.querySelector('.material-symbols-rounded');
        const textSpan = themeToggleButton.querySelector('.btn-text');

        if (currentTheme === 'dark') {
            // If current theme is dark, the button should say "Toggle Light Mode"
            iconSpan.textContent = 'light_mode'; // Sun icon
            textSpan.textContent = 'Toggle Light Mode';
        } else {
            // If current theme is light, the button should say "Toggle Dark Mode"
            iconSpan.textContent = 'dark_mode'; // Moon icon
            textSpan.textContent = 'Toggle Dark Mode';
        }
    }
}


// Call updateThemeToggleButton on load to ensure the button's state matches the initial theme
updateThemeToggleButton(); // ADD THIS LINE EXACTLY HERE

const body = document.body; /* */
const sidebar = document.getElementById("sidebar"); /* */
const toggleSidebarBtn = document.getElementById("toggleSidebarBtn"); /* */

export function toggleSidebar() { /* */
    body.classList.toggle("sidebar-collapsed"); /* */
    if (body.classList.contains('sidebar-collapsed')) { /* */
        // //toggleChatbotDropdown(false); // Close dropdown when collapsing
    }
}

if (toggleSidebarBtn) { /* */
    toggleSidebarBtn.addEventListener("click", toggleSidebar); /* */
}

export function toggleChatbotDropdown() {
    const dropdown = document.getElementById("chatbotDropdown");
    dropdown.classList.toggle("open");
}



// Helper export function to hide all main content sections
export function hideAllScreens() {
    document.getElementById("loginScreen").classList.add("hidden");
    document.getElementById("signupScreen").classList.add("hidden");
    document.getElementById("emailVerificationScreen").classList.add("hidden");
    document.getElementById("chooseBotScreen").classList.add("hidden");
    document.getElementById("chatInterface").classList.add("hidden");
    document.getElementById("settingsScreen").classList.add("hidden");
    document.querySelector(".layout-wrapper").classList.add("hidden");
    closeUpgradeToProModal(); // Ensure upgrade modal is closed when changing screens
}

export function showAuth() {
    hideAllScreens();
    document.getElementById("loginScreen").classList.remove("hidden");
    document.getElementById("authStatus").innerText = ""; // Clear status on screen change
}

export function showSignupScreen() {
    hideAllScreens();
    document.getElementById("signupScreen").classList.remove("hidden");
    document.getElementById("signupStatus").innerText = ""; // Clear status on screen change
}

export function showEmailVerificationScreen(email = "") {
    hideAllScreens();
    document.getElementById("emailVerificationScreen").classList.remove("hidden");
    const verificationEmailText = document.getElementById("verificationEmailText");
    if (email) {
        verificationEmailText.innerHTML = `An email has been sent to <b>${email}</b>. Please follow the link to verify your email address.`;
    } else {
        verificationEmailText.innerHTML = "An email has been sent to your email address. Please follow the link to verify your email address.";
    }
    document.getElementById("verificationStatus").innerText = ""; // Clear status on screen change
}

export function showBotSelect() {
    hideAllScreens();
    document.querySelector(".layout-wrapper").classList.remove("hidden");
    // //toggleChatbotDropdown(true); // Force open the dropdown for initial selection
}

export function showChat() {
    hideAllScreens();
    document.getElementById("chatInterface").classList.remove("hidden");
    document.querySelector(".layout-wrapper").classList.remove("hidden");
    //toggleChatbotDropdown(false); // Ensure dropdown is closed when chat is shown
    closeChatbotModal(); // Ensure modal is closed as fallback
}

export function showSettingsScreen() {
    hideAllScreens();
    document.getElementById("settingsScreen").classList.remove("hidden");
    document.querySelector(".layout-wrapper").classList.remove("hidden");
    //toggleChatbotDropdown(false); // Close dropdown if open
}
export function toggleMemory() {
    if (!currentUserIsPro) return showUpgradeModalForBots();
    memoryEnabled = !memoryEnabled;
    localStorage.setItem("chatMemory", JSON.stringify(memoryEnabled));
    updateMemoryToggleUI();
}


export function updateMemoryToggleUI() {
    const button = document.getElementById("chatMemoryToggleBtn");
    if (button) {
        button.disabled = !currentUserIsPro;

        if (memoryEnabled) {
            button.classList.remove("btn-secondary");
            button.classList.add("btn-primary");
            button.querySelector(".btn-text").textContent = "Chat Saving Enabled";
        } else {
            button.classList.remove("btn-primary");
            button.classList.add("btn-secondary");
            button.querySelector(".btn-text").textContent = "Enable Chat Saving";
        }
    }
}


export function toggleChatHistoryDropdown() {
    if (!currentUserIsPro) return showUpgradeModalForBots();
    const dropdown = document.getElementById("chatHistoryDropdown");
    dropdown.classList.toggle("open");
}

export function generateTitleFromMessage(msg) {
    return msg.length > 30 ? msg.slice(0, 30) + "..." : msg;
}

export function saveChatToSidebar(title, chatId) {
    const container = document.getElementById("chatHistoryDropdown");
    const button = document.createElement("button");
    button.classList.add("btn", "chatbot-dropdown-item");
    button.textContent = title;
    button.onclick = async () => {
        if (!currentUserIsPro) return showUpgradeModalForBots();
        const res = await fetch('https://ai-app-backend-zikl.onrender.com/get-conversation', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uid: auth.currentUser.uid, chatId })
        });
        const data = await res.json();
        document.getElementById("chatHistory").innerHTML = "";
        data.messages.forEach(msg => addMessage(msg.text, msg.type, msg.isImage));
    };
    container.appendChild(button);
}

